export default "__VITE_ASSET__78f12feb__"